import { useCallback } from "react";
import { getChildData } from "../../services/rcdsIntegration";
import { isAuth, getSponHistory } from "../../services/requestServices";
import {logToClientLogger} from "../../helpers/clientLogger";

export function useQueryChildData({state, dispatch}) {
  const { childInfo } = state;

  const request = useCallback(
    async (childId) => {
      if (!childId) {
        throw new Error("Child ID is empty");
      }

      if (childInfo.status === "success") {
        return childInfo.data;
      }

      dispatch({ type: "setChildInfoStatus", payload: "loading" });

      try {
        const data = await getChildData(childId);
        dispatch({ type: "setChildInfoData", payload: data });
        dispatch({ type: "setChildInfoStatus", payload: "success" });
        return data;
      } catch (err) {
        console.log(err);
        // Implement Error Handling
        logToClientLogger(err);
        dispatch({ type: "setChildInfoStatus", payload: "error" });
        return Promise.reject(err);
      }
    },
    [childInfo.status, childInfo.data, dispatch]
  );

  return {
    ...childInfo,
    request,
    isPending: childInfo.status === "pending",
    isLoading: childInfo.status === "loading",
    isWaiting: ["loading", "pending"].includes(childInfo.status),
    isError: childInfo.status === "error",
    isSuccess: childInfo.status === "success",
    isComplete: ["success", "error"].includes(childInfo.status)
  }
}

export default useQueryChildData;